<era-device-action-bar-ui [allowAssign]="allowAssign"
                          [allowSpare]="allowSpare"
                          [allowUnassign]="allowUnassign"
                          [allowUnavailable]="allowUnavailable"
                          [device]="device()"
                          [notesEnabled]="notesEnabled"
                          [assignmentHistoryEnabled]="assignmentHistoryEnabled"
                          (openNotesModalEvent)="openNotesModal()"
                          (openAssignmentHistoryModalEvent)="openAssignmentHistoryModal()">
</era-device-action-bar-ui>